/**
 * OS 22 MÓDULOS DO v6, COM NOME — e não só o número.
 *
 * A tela de governança oferecia "01, 02, 03…" para escolher o módulo de uma
 * permissão nova. O dono viu e disse o óbvio: *"isso não diz nada"*. Quem
 * cadastra uma permissão precisa saber se o `08` é combustível ou compras — e
 * a resposta existe, escrita, em `docs/product/modulos/`, desde o começo do
 * projeto. Ela só não chegava à tela.
 *
 * ## A numeração é a do v6, e só ela
 *
 * O *Registro Consolidado* conta 19 módulos e põe combustível no `7`; o v6
 * conta 22 e põe combustível no `08`. **Vale o v6**, que é o que o banco
 * guarda na coluna `org.permissao.modulo`. Essa confusão já custou caro aqui.
 *
 * ## Por que esta lista não é "mais uma cópia"
 *
 * Porque ela tem verificador: `modulos-do-v6.test.ts` lê os nomes dos arquivos
 * de `docs/product/modulos/` e exige que os 22 batam, número por número e
 * palavra por palavra. Módulo renomeado na documentação e esquecido aqui para
 * de compilar o teste — que é o único jeito de uma segunda cópia não envelhecer
 * sozinha.
 */

export interface ModuloDoV6 {
  /** Dois dígitos, como o banco guarda: `01`, `08`, `22`. */
  readonly numero: string;
  readonly nome: string;
}

export const MODULOS_DO_V6: readonly ModuloDoV6[] = [
  { numero: '01', nome: 'Cadastros e governança' },
  { numero: '02', nome: 'Equipamentos e alocação' },
  { numero: '03', nome: 'Operação, horas e paradas' },
  { numero: '04', nome: 'Integrações e conciliação' },
  { numero: '05', nome: 'Manutenção planejada' },
  { numero: '06', nome: 'Oficina e ordens de serviço' },
  { numero: '07', nome: 'Estoque e almoxarifado' },
  { numero: '08', nome: 'Abastecimento e lubrificantes' },
  { numero: '09', nome: 'Compras e reposição' },
  { numero: '10', nome: 'Checklists e ocorrências' },
  { numero: '11', nome: 'Custos e painel operacional' },
  { numero: '12', nome: 'Biblioteca técnica de ativos' },
  { numero: '13', nome: 'IA aplicada e alertas' },
  { numero: '14', nome: 'Contratos, medições e receita' },
  { numero: '15', nome: 'Financeiro gerencial e DRE' },
  { numero: '16', nome: 'Pessoas, segurança e documentos' },
  { numero: '17', nome: 'Telemetria e sensores' },
  { numero: '18', nome: 'Manutenção preditiva' },
  { numero: '19', nome: 'Orçamento e planejamento' },
  { numero: '20', nome: 'Renovação e estratégia da frota' },
  { numero: '21', nome: 'Visão do gestor' },
  { numero: '22', nome: 'Prévia visual' },
] as const;

/** `08 · Abastecimento e lubrificantes` — como a lista de escolha escreve. */
export function rotuloDoModulo(numero: string): string {
  const modulo = MODULOS_DO_V6.find((m) => m.numero === numero);
  /* O número que não está na lista aparece como está, e não some: é melhor
     mostrar um `23` sem nome do que esconder uma permissão que existe. */
  return modulo ? `${modulo.numero} · ${modulo.nome}` : numero;
}
